module.exports = __webpack_public_path__ + "img/logo.d007f2d8.png";